import React, { useState } from "react"
import toast from "react-hot-toast"

import { sendFeedback } from "api"
import isEmailValid from "utils/isEmailValid"
import isPhoneNumberValid from "utils/isPhoneNumberValid"

import Input from "components/Input/Input"
import Textarea from "components/Textarea/Textarea"

import styles from "./FeedbackForm.module.scss"

const VALUE_MIN_LENGTH = 5
const MIN_LENGTH_ERROR_MSG = `Минимум ${VALUE_MIN_LENGTH} символов`

const initialFormData = {
  email: "",
  phone: "",
  description: "",
}

const FeedbackForm = () => {
  const [formData, setFormData] = useState(initialFormData)
  const [errors, setErrors] = useState({})
  const [pending, setPending] = useState(false)

  const validateForm = () => {
    const errors = {}

    if (!isEmailValid(formData.email)) {
      errors.email = "Невалидный Email"
    }

    if (!isPhoneNumberValid(formData.phone)) {
      errors.phone = "Невалидный номер телефона"
    }

    if (formData.description.length < VALUE_MIN_LENGTH) {
      errors.description = MIN_LENGTH_ERROR_MSG
    }

    setErrors(errors)

    return Object.keys(errors).length === 0
  }

  const onChange = (fieldName, value) => {
    setFormData(prevValues => ({
      ...prevValues,
      [fieldName]: value,
    }))

    setErrors(prev => ({ ...prev, [fieldName]: null }))
  }

  const onSubmit = async evt => {
    evt.preventDefault()

    try {
      setPending(true)
      const isValid = validateForm()

      if (isValid) {
        await sendFeedback({
          email: formData.email,
          phone_number: formData.phone,
          description: formData.description,
        })

        toast.success("Успешно отправлено.")
        setFormData(initialFormData)
      }
    } catch (e) {
      console.log(e)
      toast.error("Не удалось отправить")
    } finally {
      setPending(false)
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.block}>
        <div className={styles.title}>
          <h2>Если вы увидели неточность на карте — свяжитесь с нами</h2>
        </div>

        <form className={styles.form} onSubmit={onSubmit}>
          <Input
            id="feedback-email"
            value={formData.email}
            error={errors?.email}
            placeholder="Электронная почта"
            onChange={val => onChange("email", val)}
          />
          <Input
            id="feedback-phone"
            value={formData.phone}
            error={errors?.phone}
            placeholder="Номер телефона"
            onChange={val => onChange("phone", val)}
          />
          <Textarea
            id="feedback-description"
            value={formData.description}
            error={errors?.description}
            placeholder="Короткое описание"
            onChange={val => onChange("description", val)}
          />

          <div className={styles.submitButtonWrap}>
            <button
              type="submit"
              className={styles.submitButton}
              disabled={pending}
            >
              Отправить
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default FeedbackForm
